// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__8lqqW","cell":"ColumnAccessor_cell__1NVap","firstCellAccent":"ColumnAccessor_firstCellAccent__CuR7I"};